// extracted by mini-css-extract-plugin
module.exports = {"dark":"DisplayIf-module--dark--3P_nH","desktop-only":"DisplayIf-module--desktop-only--22UtF","mobile-only":"DisplayIf-module--mobile-only--2zPqt"};